const fallbackExecCommandCopy = (text: string): boolean => {
  if (typeof document === "undefined") {
    return false;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "true");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  textarea.style.pointerEvents = "none";
  document.body.appendChild(textarea);

  textarea.focus();
  textarea.select();

  let copied = false;
  try {
    copied = document.execCommand("copy");
  } catch {
    copied = false;
  }

  document.body.removeChild(textarea);
  return copied;
};

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  const payload = String(text ?? "");

  const clipboardApi =
    typeof navigator !== "undefined" ? navigator.clipboard : undefined;

  if (clipboardApi?.writeText) {
    try {
      await clipboardApi.writeText(payload);
      return true;
    } catch {
      // Fall through to execCommand fallback.
    }
  }

  const copiedWithExec = fallbackExecCommandCopy(payload);
  return copiedWithExec;
};
